<template>
  <card-content
    :loader="isLoading"
    :items="videoList"
    type="video"
    :fileTypes="fileType"
  >
    <template slot="item-preview" slot-scope="{ url }">
      <img class="multimedia__thumbnail" :src="url"/>
      <div class="multimedia__button">
        <play-icon class="multimedia__icon"/>
      </div>
    </template>
  </card-content>
</template>

<script>

export default {
  props: {
    databank: {
      required: true,
    },
  },
  components: {
    CardContent: () => import('@/components/settings/dataBank/MediaComponents/CardContent.vue'),
  },
  data() {
    return {
      videoList: [],
      fileType: 'video/*',
    };
  },
  computed: {
    isLoading() {
      return this.databank.video === null;
    },
  },
  mounted() {
    this.videoList = this.databank.video || [];
  },
  watch: {
    'databank.video': function setVideo(newVideo) {
      this.videoList = newVideo || [];
    },
  },
};
</script>
